const __WEBPACK_NAMESPACE_OBJECT__ = require("@matillion/hub-client");